import React, { useContext, useState } from "react";

import "./style.scss";
// import data from "./data";
import clsx from "clsx";
import { LanguageContext, text } from "../../container/language";
import InfoTable from "../InfoTable"

const Tabs = ({ data }) => {
    const {userLanguage} = useContext(LanguageContext)
    const [active, setActive] = useState(0)

    return (
        <div className="tabs js-tabs">
            {
                data.map(({title, body}, idx) => (
                    <>
                        <div className={clsx("tabs__link js-tabs__link", { "is-active": active === idx })} onClick={() => setActive(idx)}>
                            <font><font>{text(title, userLanguage)}</font></font>
                        </div>

                        <div className={clsx("tabs__content js-tabs__content", { "is-active": active === idx })}>
                            <section className="site-block" dangerouslySetInnerHTML={{__html: text(body, userLanguage)}} />
                        </div>
                    </>
                ))
            }
        </div>
    )
}

export default Tabs;